<template>
  <div>
    <v-row no-gutters justify="center" align="center" class="py-6" v-if="isFetchingSignup">
      <v-progress-circular indeterminate color="accent" />
    </v-row>
    <div v-else-if="hasSignup">
      <div class="text-center text-h6 pt-6 pb-4">
        Votre espace est créé 🚀
      </div>
      <div class="mt-5 text-center">
        Tout est en ordre, nous avons fait le nécessaire et votre espace Indeego est maintenant créé.
      </div>
      <div class="text-h3 text-center py-5">📬</div>
      <div class="text-center">
        Il ne vous reste plus qu'à vérifier votre boite de réception pour valider votre compte !
      </div>
    </div>
    <div v-else>
      <div class="text-center text-h6 pt-6 pb-4">
        Inscription non trouvée 🙁
      </div>
      <div class="mt-5 text-center">
        Un problème est survenu lors de la récupération de votre inscription, veuillez réessayer ou recommencer.
      </div>
      <v-row no-gutters justify="center" align="center" class="mt-5">
        <v-btn
          rounded
          depressed
          color="primary"
          class="submit-btn"
          @click="gToFirstStep"
        >
          👈 Recommencer
        </v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapMutations, mapState } from 'vuex';
import api from '@/api';

const DEFAULT_ERROR_MESSAGE = `Une erreur inconnue s'est produite, merci de réessayer`;

export default {
  data: () => ({
    // signup: {},
    companyName: ``,
    slug: ``,
    isFetchingSignup: false,
    isSignupNotFound: false,
    isSlugManuallyUpdated: false,
    isCheckingSlug: true,
    isSlugAvailable: false,
    isSlugAvailabilityChecked: false,
    isSubmitting: false,
    areLegaleInformationsAccepted: false,
    error: ``,
    checkSlugId: 1,
  }),

  computed: {
    ...mapState([
      `signupStep`,
    ]),
    ...mapState({
      storeSignup: `signup`,
    }),
    step: {
      get() { return this.signupStep; },
      set(value) { return this.SET_SIGNUP_STEP(value); },
    },
    signup: {
      get() { return this.storeSignup; },
      set(value) { return this.SET_SIGNUP(value); },
    },
    token() {
      return this.$route.params?.token || null;
    },
    hasSignup() {
      return Boolean(this.signup?.token);
    },
    hasError() {
      return this.error?.length > 0;
    },
    cleanCompanyName() {
      return _.trim(this.companyName);
    },
    cleanSlug() {
      return _.trim(this.slug);
    },
    isCompanyNameLengthValid() {
      return this.cleanCompanyName.length >= 3;
    },
    isSlugLengthValid() {
      return this.cleanSlug.length >= 3;
    },
    isSlugValid() {
      const slugWithoutAllowedChars = this.cleanSlug
        .replace(/[A-Za-z]/g, ``)
        .replace(/[0-9]/g, ``)
        .replace(/-/g, ``);
      const slugWithoutDashes = this.cleanSlug.replace(/-/g, ``);

      return this.isSlugLengthValid
             && slugWithoutDashes.length
             && !slugWithoutAllowedChars.length
             && !this.cleanSlug.startsWith(`-`);
    },
    canSubmit() {
      return this.isCompanyNameLengthValid
             && this.isSlugValid
             && this.isSlugAvailable
             && this.areLegaleInformationsAccepted;
    },
  },

  methods: {
    ...mapMutations([
      `SET_SIGNUP_STEP`,
      `SET_SIGNUP`,
    ]),
    async fetchSignupIfNeeded() {
      if (this.signupStep === 3 && !this.hasSignup) {
        this.isFetchingSignup = true;
        try {
          const { data: signup } = await this.$api.get(`/signup/${this.token}`);
          this.signup = signup;
          if (this.hasSignup) {
            window.$crisp.push([`set`, `user:nickname`, [`${signup.userFirstname} ${signup.userLastname}`]]);
            window.$crisp.push([`set`, `user:email`, [signup.userEmail]]);
          } else {
            this.isSignupNotFound = true;
          }
        } catch (e) {} // eslint-disable-line
        this.isFetchingSignup = false;
      }
    },
    gToFirstStep() {
      this.$router.replace(`/signup`);
    },
    computeSlug() {
      if (!this.isSlugManuallyUpdated) {
        this.slug = _.kebabCase(this.cleanCompanyName.toLowerCase());
      }
    },
    checkSlug() {
      this.isSlugAvailable = false;
      this.checkSlugId += 1;
      const id = this.checkSlugId;
      clearTimeout(this.checkSlugTimeout);
      this.isCheckingSlug = true;
      this.checkSlugTimeout = setTimeout(async () => {
        let isSlugAvailable = false;
        try {
          const { data: { isAvailable } } = await this.$api.post(`/signup/${this.token}/check-slug`, { slug: this.cleanSlug });
          isSlugAvailable = isAvailable === true;
        } catch (e) {} // eslint-disable-line
        if (this.checkSlugId === id) {
          this.isSlugAvailable = isSlugAvailable;
          this.isCheckingSlug = false;
        }
      }, 500);
    },
    async submit() {
      this.isSubmitting = true;
      try {
        const { data: { success, error } } = await api.post(`/signup/${this.token}/space`, {
          name: this.cleanCompanyName,
          slug: this.cleanSlug,
        });
        if (success) {
          this.$router.replace(`/signup/${this.token}/check-email`);
        } else {
          this.error = error || DEFAULT_ERROR_MESSAGE;
        }
      } catch (e) {
        this.error = DEFAULT_ERROR_MESSAGE;
      }
      this.isSubmitting = false;
    },
  },

  mounted() {
    this.fetchSignupIfNeeded();
  },

  watch: {
    signupStep() {
      this.fetchSignupIfNeeded();
    },
    companyName() {
      this.computeSlug();
    },
    slug() {
      if (this.isSlugValid) {
        this.checkSlug();
      }
    },
  },
};
</script>

<style lang="scss">
.slug-input {
  input {
    text-align: right !important;
  }
}
</style>
